import { useMemo } from 'react'

export const useTextParts = (text: string | undefined) => {
  return useMemo(() => text?.split('\n'), [text])
}
